import { Sheet, SheetContent } from '@/shared/widgets/sheet';
import type { ListingFilter } from '@/features/plp/domain/models/ProductListing';
import { RecommendedBrowseFiltersPanel } from './RecommendedBrowseFiltersPanel';

export interface RecommendedBrowseFilterSheetProps {
  open: boolean;
  filters: ListingFilter[];
  selectedOptions: Record<string, string[]>;
  applyUrl: string | null;
  isLoadingPreview: boolean;
  filtersResetUrl?: string;
  onToggleOption: (category: string, name: string, url: string) => void;
  onApply: () => void;
  onReset: () => void;
  onClose: () => void;
}

export function RecommendedBrowseFilterSheet({
  open,
  filters,
  selectedOptions,
  applyUrl,
  isLoadingPreview,
  filtersResetUrl,
  onToggleOption,
  onApply,
  onReset,
  onClose,
}: RecommendedBrowseFilterSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onClose(); }}>
      <SheetContent
        side="bottom"
        className="left-0 right-0 bottom-0 h-[100dvh] max-h-[100dvh] rounded-none p-0 flex flex-col shadow-[0_-8px_32px_rgba(0,0,0,0.12)]"
        showCloseButton={false}
      >
        <RecommendedBrowseFiltersPanel
          className="h-full max-h-[100dvh]"
          filters={filters}
          selectedOptions={selectedOptions}
          applyUrl={applyUrl}
          isLoadingPreview={isLoadingPreview}
          filtersResetUrl={filtersResetUrl}
          onToggleOption={onToggleOption}
          onApply={onApply}
          onReset={onReset}
          onClose={onClose}
        />
      </SheetContent>
    </Sheet>
  );
}
